import(/* webpackMode: "eager" */ "/home/runner/work/ceylon-bike-rent/ceylon-bike-rent/src/app/contact/page.tsx");
